module.exports = __webpack_public_path__ + "img/ico-paragraph.2a75952e.svg";